import axios from 'axios'

const actions = ['personal', 'haircut', 'manicure', 'clothes', 'travel', 'givecredit', 'takecredit'];

var actionsOn = JSON.parse(localStorage.getItem('actionsOn') || '{}');
if (Object.entries(actionsOn).length == 0)
  actions.forEach(action => actionsOn[action] = true)

const dayLength = 86400
const preloadOffset = 3 * dayLength
const daysInPast = 14
export const predictions = {
  namespaced: true,
  state: {
    daypredictions: {},
    days: {},
    panchanga: {
      dates: [],
      varas: [],
      nakshatras: [],
      tithis: [],
      karanas: [],
      yogas: [],
      qualityMap: [],
    },
    actionsOn: actionsOn,
    actions: actions,
    current: {
      day: undefined,
      month: undefined,
    },
  },
  mutations: {
    SET_DAYPREDICTIONS (state, set) {
      state.daypredictions = { ...state.daypredictions, [set.month]: set.daypredictions }
    },
    CLEAR_DAYPREDICTIONS (state) {
      state.daypredictions = {}
    },
    SET_DAYS (state, set) {
      state.days = { ...state.days, [set.month]: set.days }
    },
    CLEAR_DAYS (state) {
      state.days = {}
    },
    SET_INTERVALS (state, intervals) {
      state.panchanga[intervals.type] = intervals.list
    },
    CLEAR_INTERVALS (state) {
      state.panchanga = {
        dates: [],
        varas: [],
        nakshatras: [],
        tithis: [],
        karanas: [],
        yogas: [],
        qualityMap: [],
      }
    },
    ADD_INTERVALS_LEFT (state, intervals) {
      while (intervals.list.length > 0) {
        state.panchanga[intervals.type].unshift(intervals.list[intervals.list.length - 1])
        intervals.list.pop()
      }
    },
    ADD_INTERVALS_RIGHT (state, intervals) {
      while (intervals.list.length > 0) {
        state.panchanga[intervals.type].push(intervals.list[0])
        intervals.list.shift()
      }
    },
    SET_QUALITY_MAP (state, map) {
      state.panchanga.qualityMap = map
    },
    SET_CURRENT_MONTH (state, month) {
      state.current.month = new Date(month)

      if (! state.current.day || state.current.day.getMonth() != month.getMonth()) 
        state.current.day = new Date(month)
    },
    SET_CURRENT_DAY (state, day) {
      state.current.day = new Date(day)

      if (! state.current.month || state.current.month.getMonth() != day.getMonth()) {
        var month = day
        month.setDate(1)
        state.current.month = new Date(month)
      }
    },
    SET_ACTION_STATE (state, set) {
      state.actionsOn[set.action] = set.state
      localStorage.setItem('actionsOn', JSON.stringify(state.actionsOn))
    },
  },
  actions: {
    loadData(context) {
      context.dispatch('loadDayPredictions')
      context.dispatch('loadCalendar')
      context.dispatch('loadPanchanga')
    },
    reloadData(context) {
      context.commit('CLEAR_DAYPREDICTIONS')
      context.commit('CLEAR_DAYS')
      context.commit('CLEAR_INTERVALS')
      context.dispatch('loadData')
    },
    loadDayPredictions (context) {
      if (context.state.days[context.getters.currentMonth] !== undefined) 
        return

      axios
        .get('/api/daypredictions/' + context.getters.currentMonth)
        .then(({ data }) => {
          context.commit('SET_DAYPREDICTIONS', { month: context.getters.currentMonth, daypredictions: data.predictions })
        })
    },
    loadCalendar (context) {
      if (context.state.days[context.getters.currentMonth] && context.state.days[context.getters.currentMonth].length > 0) 
        return

      axios
        .get('/api/calendar/' + context.getters.currentMonth)
        .then(({ data }) => {
          context.commit('SET_DAYS', { month: context.getters.currentMonth, days: data.days })
        })
    },
    loadPanchanga (context) {
      var dates, month
      if (context.state.panchanga.dates.length == 0) {
        if (context.state.current.month > context.getters.firstAvailableDate 
          && context.rootGetters['auth/canUse']('panchanga-details-unlimited')) {
          dates = context.getters.panchangaDates(context.getters.firstAvailableDate)
          dates = dates.concat(context.getters.panchangaDates(context.state.current.month))
        } else 
          dates = context.getters.panchangaDates(context.state.current.month)

        context.commit('SET_INTERVALS', { type: 'dates', list: dates })
        return context.dispatch('loadPanchangaRange', { from: dates[0].start, to: dates[dates.length - 1].start + dayLength})
      }
        
      if (context.rootGetters['auth/canUse']('panchanga-details-unlimited')
        && context.state.current.day.getTime() / 1000 > 
          context.state.panchanga.dates[context.state.panchanga.dates.length - 1].start - preloadOffset + dayLength) {
        month = new Date(context.state.current.month)
        if (month.getTime() / 1000 < context.state.panchanga.dates[context.state.panchanga.dates.length - 1].start + dayLength) 
          month = context.getters.nextMonth

        dates = context.getters.panchangaDates(month)
        context.dispatch('loadPanchangaRange', { from: dates[0].start, to: dates[dates.length - 1].start + dayLength})
        context.commit('ADD_INTERVALS_RIGHT', { type: 'dates', list: dates })
      }
    },
    loadPanchangaRange (context, range) {
      return axios
        .get('/api/panchanga?from=' + range.from + '&to=' + range.to)
        .then(({ data }) => {
          for (let [type, list] of Object.entries(data.intervals)) {
            if (context.state.panchanga[type].length === 0) {
              context.commit('SET_INTERVALS', { type: type, list: list })
            } else if (list[0].start < context.state.panchanga[type][0].start) {
              if (list[list.length - 1].start >= context.state.panchanga[type][0].start) 
                list.pop()
              context.commit('ADD_INTERVALS_LEFT', { type: type, list: list })
            } else if (list[list.length - 1].end > context.state.panchanga[type][context.state.panchanga[type].length - 1].end) {
              if (list[0].end <= context.state.panchanga[type][context.state.panchanga[type].length - 1].end) 
                list.shift()
              context.commit('ADD_INTERVALS_RIGHT', { type: type, list: list })
            }
          }
          context.commit('SET_QUALITY_MAP', data.qualityMap)
        })
    },
    setCurrentDay (context, day) {
      if (! day && context.state.current.day)
        return
      var date
      if (day) {
        date = new Date(day)
        if (typeof day === 'string')
          date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
        date.setHours(12)
      } else {
        date = context.state.current.month ? new Date(context.state.current.month) : new Date(Date.now())
      }
      if (date < context.getters.firstAvailableDate)
        date = context.getters.firstAvailableDate

      context.commit('SET_CURRENT_DAY', date)
      return context.dispatch('loadData')
    },
    setNextDay (context) {
      var day = context.getters.nextDay
      context.commit('SET_CURRENT_DAY', day)
      context.dispatch('loadData')
    },
    setPreviousDay (context) {
      var day = context.getters.previousDay
      if (day < context.getters.firstAvailableDate)
        return
      context.commit('SET_CURRENT_DAY', day)
      context.dispatch('loadData')
    },
    setCurrentMonth (context, month) {
      if (! month && context.state.current.month)
        return

      if (! month && ! context.state.current.day) {
        context.dispatch('setCurrentDay')
        return
      }

      var date
      if (month) {
        date = new Date(month)
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
      } else {
        date = new Date(context.state.current.day)
      }
      date.setDate(1)
      if (date < context.getters.firstAvailableDate)
        date = context.getters.firstAvailableDate

      date.setHours(12)
      date.setMinutes(0)
      context.commit('SET_CURRENT_MONTH', date)
      context.dispatch('loadData')
    },
    setNextMonth (context) {
      context.commit('SET_CURRENT_MONTH', context.getters.nextMonth)
      context.dispatch('loadData')
    },
    setPreviousMonth (context) {
      var month = context.getters.previousMonth
      if (month < context.getters.firstAvailableDate)
        month = context.getters.firstAvailableDate
      context.commit('SET_CURRENT_MONTH', month)
      context.dispatch('loadData')
    },
    actionToggle (context, action) {
      context.commit('SET_ACTION_STATE', { action: action, state: ! context.state.actionsOn[action] })
    },
    actionOnly (context, action) {
      for(let iterator of context.state.actions)
        context.commit('SET_ACTION_STATE', { action: iterator, state: iterator == action })
    },
  },
  getters: {
    currentMonth(state) {
        var month = '0' + (state.current.month.getMonth() + 1)
        month = month.substring(month.length - 2)
        return state.current.month.getFullYear() + '-' + month
    },
    currentDay(state, getters) {
        var day = '0' + (state.current.day.getDate())
        day = day.substring(day.length - 2)
        return getters.currentMonth + '-' + day
    },
    currentMonthDays(state, getters) {
      if (! state.days[getters.currentMonth] || state.days[getters.currentMonth].length == 0) 
        return []

      return state.days[getters.currentMonth]
    },
    daysInMonth: (state) => (month = undefined) => {
        var day = new Date(month ? month : state.current.month)
        day.setMonth(day.getMonth() + 1)
        day.setDate(0)
        return day.getDate()
    },
    daysToSkip(state) {
        var day = new Date(state.current.month)
        return day.getDay() != 0 ? day.getDay() - 1 : 6
    },
    dayAvailable: (state, getters) => (day) => {
      var month = getters.currentMonth
      if (state.days[month] && state.days[month].length == 0
        || state.days[month] && state.days[month].length > 0 
          && state.days[month][day - 1] 
          && state.days[month][day - 1]['disabled'])
        return false

      if (state.current.month.getFullYear() > getters.firstAvailableDate.getFullYear())
        return true

      if (state.current.month.getMonth() > getters.firstAvailableDate.getMonth())
        return true

      return day >= getters.firstAvailableDate.getDate()
    },
    actionHasQuality: (state, getters) => (day, action, quality) => {
      var month = getters.currentMonth
      if (state.days[month] === undefined
        || state.days[month].length == 0 
        || state.days[month][day - 1] === undefined 
        || state.days[month][day - 1][action] === undefined 
        || state.days[month][day - 1][action].length == 0)
        return false

      return state.days[getters.currentMonth][day - 1][action].find(element => element.quality === quality) !== undefined
    },
    dayPrediction(state, getters, rootState) {
      var month = getters.currentMonth
      if (state.daypredictions[month] === undefined
        || state.daypredictions[month].length == 0)
        return ''

      var index = state.daypredictions[month].findIndex(element => element.day == getters.currentDay)

      if (index == -1 || state.daypredictions[month][index] === undefined
        || state.daypredictions[month][index].prediction[rootState.locale.locale] === undefined)
        return ''

      return state.daypredictions[month][index].prediction[rootState.locale.locale].replace(/\n/g, "<br>")
    },
    dayIntervals: (state, getters) => (action) => {
      var month = getters.currentMonth
      var dayIndex = state.current.day.getDate() - 1
      if (state.days[month] === undefined
        || state.days[month].length == 0 
        || state.days[month][dayIndex] === undefined 
        || state.days[month][dayIndex][action] === undefined 
        || state.days[month][dayIndex][action].length == 0)
        return []

      return state.days[month][dayIndex][action]
    },
    actionIcon: () => (action) => {
      return 'Icon' + action.charAt(0).toUpperCase() + action.substring(1)
    },
    panchangaDates: (state, getters, rootState, rootGetters) => (month) => {
        var zeroDay, dayStart, dayYear, dayMonth, days, dates = []

        if (! rootGetters['auth/canUse']('panchanga-details-unlimited')) 
          month = new Date(Date.now())

        dayYear = month.getFullYear()
        dayMonth = month.getMonth()
        zeroDay = month.getDate()

        if (rootGetters['auth/canUse']('panchanga-details-unlimited')) 
          days = getters.daysInMonth(month) - zeroDay + 1
        else
          days = 2

        for (let i = 0; i < days; i++) {
          dayStart = new Date(dayYear, dayMonth, zeroDay + i).getTime() / 1000 
          dates.push({ 
            start: dayStart, 
            length: new Date(dayYear, dayMonth, zeroDay + i + 1).getTime() / 1000 - dayStart 
          })
        }
        return dates
    },
    panchangaZero(state) {
      return state.panchanga.dates[0] ? state.panchanga.dates[0].start : undefined
    },
    nakshatraPersonalQuality: (state) => (nakshatra) => {
      if (state.panchanga.qualityMap[nakshatra] === undefined)
        return null

      return state.panchanga.qualityMap[nakshatra]
    },
    firstAvailableDate() {
      var now = new Date(Date.now())
      now.setHours(0)
      now.setMinutes(0)
      now.setSeconds(0)
      now.setDate(now.getDate() - daysInPast)
      return now
    },
    nextMonth(state) {
      var month = new Date(state.current.month)
      month.setMonth(month.getMonth() + 1)
      month.setDate(1)
      month.setHours(12)
      month.setMinutes(0)
      month.setSeconds(0)
      return month
    },
    previousMonth(state) {
      var month = new Date(state.current.month)
      month.setMonth(month.getMonth() - 1)
      month.setDate(1)
      month.setHours(12)
      month.setMinutes(0)
      month.setSeconds(0)
      return month
    },
    nextDay(state) {
      var day = new Date(state.current.day)
      day.setDate(day.getDate() + 1)
      day.setHours(12)
      day.setMinutes(0)
      day.setSeconds(0)
      return day
    },
    previousDay(state) {
      var day = new Date(state.current.day)
      day.setDate(day.getDate() - 1)
      day.setHours(12)
      day.setMinutes(0)
      day.setSeconds(0)
      return day
    },
    currentVara(state, getters) {
      var month = getters.currentMonth
      var dayIndex = state.current.day.getDate() - 1
      if (state.days[month] === undefined
        || state.days[month].length == 0 
        || state.days[month][dayIndex] === undefined
        || state.panchanga.varas.length == 0)
        return null

      var day = state.days[month][dayIndex].day
      return state.panchanga.varas.find(vara => {
        return (vara.start >= day.begin && vara.start <= day.end || vara.start <= day.begin && vara.end >= day.end)
      })
    },
  },
};